import { clsx, type ClassValue } from 'clsx';

/** Junta classes condicionais (clsx). */
export function cn(...values: ClassValue[]) {
  return clsx(values);
}
